import React from 'react';
import { TableLayout } from 'lib/components/TableLayout';
import { ENotice, ESnapshotExists } from 'lib/types';
import { Badge } from 'lib/components/Badge/Badge';
import { getModelFromSnapshot } from 'lib/model';
import { UserNoticeModel } from 'lib/model/objects/userNoticeModel';
import { getFirebaseContext } from 'utils/firebase';
import { CheckIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { NoticesOverviewRow } from './NoticesOverviewRow';

type NoticesOverviewProps = {
  notices: ESnapshotExists<ENotice>[];
  loading: boolean;
};
export function NoticesOverviewTable(props: NoticesOverviewProps) {
  const columns = ['Notice', 'Custom Id', 'Confirmed', 'Invoiced', 'View'];

  const { notices, loading } = props;

  return (
    <div id="notices-table" className="overflow-scroll">
      <TableLayout
        filterable={{
          searchEnabled: false,
          shouldShowTableItem: () => true
        }}
        loading={loading}
        renderRow={notice => <NoticesOverviewRow notice={notice} />}
        header={{
          title: 'Notices',
          subtitle: 'All notices for this publication issue',
          additionalContent: <PublicationIssueSummary notices={notices} />
        }}
        columns={columns}
        data={notices}
        pagination={{ pageSize: 15 }}
      />
    </div>
  );
}

function PublicationIssueSummary({
  notices
}: {
  notices: ESnapshotExists<ENotice>[];
}) {
  const firebaseContext = getFirebaseContext();
  const noticeModels = notices.map(notice =>
    getModelFromSnapshot(UserNoticeModel, firebaseContext, notice)
  );
  const totalNotices = noticeModels.length;
  const totalInvoicedNotices = noticeModels.filter(
    noticeModel => !!noticeModel.modelData.invoice
  ).length;
  const totalConfirmedNotices = noticeModels.filter(
    noticeModel => noticeModel.isConfirmed
  ).length;

  const allNoticesInvoiced =
    totalNotices > 0 && totalNotices === totalInvoicedNotices;
  const allNoticesConfirmed =
    totalNotices > 0 && totalNotices === totalConfirmedNotices;

  return (
    <div className="flex space-y-2 flex-col">
      <Badge
        startIcon={
          allNoticesConfirmed ? (
            <CheckIcon className="w-4 h-4" />
          ) : (
            <ExclamationCircleIcon className="w-4 h-4" />
          )
        }
        status={allNoticesConfirmed ? 'success' : 'warning'}
      >
        {totalConfirmedNotices} / {totalNotices} Confirmed
      </Badge>
      <Badge
        startIcon={
          allNoticesInvoiced ? (
            <CheckIcon className="w-4 h-4" />
          ) : (
            <ExclamationCircleIcon className="w-4 h-4" />
          )
        }
        status={allNoticesInvoiced ? 'success' : 'warning'}
      >
        {totalInvoicedNotices} / {totalNotices} Invoiced
      </Badge>
    </div>
  );
}
